// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// @generated by protobuf-ts 2.9.6 with parameter force_server_none,optimize_code_size,ts_nocheck
// @generated from protobuf file "sui/forking/v1alpha/forking_service.proto" (package "sui.forking.v1alpha", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
//
import type { RpcTransport } from '@protobuf-ts/runtime-rpc';
import type { ServiceInfo } from '@protobuf-ts/runtime-rpc';
import { ForkingService } from './forking_service.js';
import type { GetStatusResponse } from './forking_service.js';
import type { GetStatusRequest } from './forking_service.js';
import type { AdvanceCheckpointResponse } from './forking_service.js';
import type { AdvanceCheckpointRequest } from './forking_service.js';
import { stackIntercept } from '@protobuf-ts/runtime-rpc';
import type { AdvanceClockResponse } from './forking_service.js';
import type { AdvanceClockRequest } from './forking_service.js';
import type { UnaryCall } from '@protobuf-ts/runtime-rpc';
import type { RpcOptions } from '@protobuf-ts/runtime-rpc';
/**
 * Administrative service for controlling a forked Sui network.
 *
 * @generated from protobuf service sui.forking.v1alpha.ForkingService
 */
export interface IForkingServiceClient {
	/**
	 * Advance the forked network's clock by a given duration.
	 *
	 * @generated from protobuf rpc: AdvanceClock(sui.forking.v1alpha.AdvanceClockRequest) returns (sui.forking.v1alpha.AdvanceClockResponse);
	 */
	advanceClock(
		input: AdvanceClockRequest,
		options?: RpcOptions,
	): UnaryCall<AdvanceClockRequest, AdvanceClockResponse>;
	/**
	 * Seal pending transactions into a new checkpoint.
	 *
	 * @generated from protobuf rpc: AdvanceCheckpoint(sui.forking.v1alpha.AdvanceCheckpointRequest) returns (sui.forking.v1alpha.AdvanceCheckpointResponse);
	 */
	advanceCheckpoint(
		input: AdvanceCheckpointRequest,
		options?: RpcOptions,
	): UnaryCall<AdvanceCheckpointRequest, AdvanceCheckpointResponse>;
	/**
	 * Return the current state of the forked network.
	 *
	 * @generated from protobuf rpc: GetStatus(sui.forking.v1alpha.GetStatusRequest) returns (sui.forking.v1alpha.GetStatusResponse);
	 */
	getStatus(
		input: GetStatusRequest,
		options?: RpcOptions,
	): UnaryCall<GetStatusRequest, GetStatusResponse>;
}
/**
 * Administrative service for controlling a forked Sui network.
 *
 * @generated from protobuf service sui.forking.v1alpha.ForkingService
 */
export class ForkingServiceClient implements IForkingServiceClient, ServiceInfo {
	typeName = ForkingService.typeName;
	methods = ForkingService.methods;
	options = ForkingService.options;
	constructor(private readonly _transport: RpcTransport) {}
	/**
	 * Advance the forked network's clock by a given duration.
	 *
	 * @generated from protobuf rpc: AdvanceClock(sui.forking.v1alpha.AdvanceClockRequest) returns (sui.forking.v1alpha.AdvanceClockResponse);
	 */
	advanceClock(
		input: AdvanceClockRequest,
		options?: RpcOptions,
	): UnaryCall<AdvanceClockRequest, AdvanceClockResponse> {
		const method = this.methods[0],
			opt = this._transport.mergeOptions(options);
		return stackIntercept<AdvanceClockRequest, AdvanceClockResponse>(
			'unary',
			this._transport,
			method,
			opt,
			input,
		);
	}
	/**
	 * Seal pending transactions into a new checkpoint.
	 *
	 * @generated from protobuf rpc: AdvanceCheckpoint(sui.forking.v1alpha.AdvanceCheckpointRequest) returns (sui.forking.v1alpha.AdvanceCheckpointResponse);
	 */
	advanceCheckpoint(
		input: AdvanceCheckpointRequest,
		options?: RpcOptions,
	): UnaryCall<AdvanceCheckpointRequest, AdvanceCheckpointResponse> {
		const method = this.methods[1],
			opt = this._transport.mergeOptions(options);
		return stackIntercept<AdvanceCheckpointRequest, AdvanceCheckpointResponse>(
			'unary',
			this._transport,
			method,
			opt,
			input,
		);
	}
	/**
	 * Return the current state of the forked network.
	 *
	 * @generated from protobuf rpc: GetStatus(sui.forking.v1alpha.GetStatusRequest) returns (sui.forking.v1alpha.GetStatusResponse);
	 */
	getStatus(
		input: GetStatusRequest,
		options?: RpcOptions,
	): UnaryCall<GetStatusRequest, GetStatusResponse> {
		const method = this.methods[2],
			opt = this._transport.mergeOptions(options);
		return stackIntercept<GetStatusRequest, GetStatusResponse>(
			'unary',
			this._transport,
			method,
			opt,
			input,
		);
	}
}
